<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 v-if="organizationUnitId" :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">{{title}}</h1>

                    <a :href="`/#/admin/organizations/workspaces/${organizationUnitId}`" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>

                    <a :href="`/#/admin/organizations/workspaces/edit/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                        <span>Edit</span>
                    </a>
                </div>
                <div class="col-lg-5 text-right">
                    <FileUploader :ttl="60" :skipConfirmation="true" :hideProgress="true" @selected="file=$event" @uploaded="handleFileUploaded">
                        <button type="button" class="btn btn-success">Upload portfolio</button>
                    </FileUploader>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div v-if="usersInWorkspace.length" style="margin-bottom: 50px;">
                <h4 class="fg-color-blue">Members</h4>
                <br />

                <table class="table table-striped table-hover">
                    <tbody>
                        <tr v-for="u in usersInWorkspace">
                            <td>{{u.DisplayName}}</td>
                            <td>{{u.Email}}</td>
                            <td>{{u.IsExternal ? 'External' : 'Organization'}}</td>
                            <td>
                                <button @click="handleRemoveUserFromWorkspaceCommandV1(u)" class="btn btn-secondary btn-sm pull-right">
                                    Remove an access
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style="margin-bottom: 40px;">
                <h4 class="fg-color-blue">Invite people from outside the organization</h4>

                <ul v-if="invitations.length">
                    <li v-for="email in invitations" :key="email">Pending invitation for {{email}}</li>
                </ul>

                <div class="input-group mb-3">
                    <input v-model.trim="inputRecipientEmail" type="text" class="form-control" placeholder="By email">
                    <div class="input-group-append">
                        <button @click="handleInviteToWorkspaceCommandV1" class="btn btn-primary" type="button">Invite</button>
                    </div>
                </div>
                <br />

                <div class="row">
                    <div v-for="u in usersNotInWorkspace" class="col-sm-6" style="margin-bottom: 20px;">
                        <div class="card bg-light">
                            <div class="card-header">
                                Organization user
                                <button @click="handleAddUserToWorkspaceCommandV1(u)" class="btn btn-primary btn-sm pull-right">
                                    Add <i class="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div class="card-body">
                                <h5 class="card-title">{{u.DisplayName}}</h5>
                                <p class="card-text"><em>{{u.Email}}</em></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Workspaces/Domain/queries-vue-component";
    import Commands from "@Organizations/Workspaces/Domain/commands-vue-component";
    import UsersQueries from "@Organizations/Users/Domain/queries-vue-component";
    import FileUploader from '@Blobs/Components/FileUploader.vue';
    import "@common/AdminNavigationV2.vue";

    @Component({ components: { FileUploader } })
    export default class ManageWorkspacePage extends mixins(PageBase, PageStatus, Queries, UsersQueries, Commands) {
        mounted() {
            this.setTitle(this.title);
            this.runWorkspaceMembersQueryV1(this.id);
        }

        file: File | null = null;
        inputRecipientEmail: string = null;

        get workspaceMembersModel() { return this.model?.WorkspaceMembers; }
        get organizationUnitId() { return this.workspaceMembersModel?.OrganizationUnitId; }
        get workspaceName() { return this.workspaceMembersModel?.WorkspaceName; }
        get usersInWorkspace() { return this.workspaceMembersModel?.UsersInWorkspace || []; }
        get usersNotInWorkspace() { return this.workspaceMembersModel.UsersNotInWorkspace || []; }
        get invitations() { return this.workspaceMembersModel.Invitations || []; }
        get title() { return `Manage ${this.workspaceName || 'workspace'}`; }

        titleChanged(title) {
            this.setTitle(title);
        }

        succeedAnyCommand(status) {
            this.runWorkspaceMembersQueryV1(this.id);
        }

        handleAddUserToWorkspaceCommandV1(user) {
            this.invokeAddUserToWorkspaceCommandV1(this.id, user.UserId);
        }

        handleInviteToWorkspaceCommandV1() {
            this.invokeInviteToWorkspaceCommandV1(this.id, this.inputRecipientEmail);
            this.inputRecipientEmail = null;
        }

        handleRemoveUserFromWorkspaceCommandV1(user) {
            if (confirm(`Do you want to remove user ${user.Email} from workspace?`))
                this.invokeRemoveUserFromWorkspaceCommandV1(this.id, user.UserId);
        }

        handleFileUploaded(blobId: string) {
            if (confirm(`Do you really want to import '${this.file.name}' into '${this.workspaceName}' workspace?`)) {
                this.invokeImportToWorkspaceCommandV1(this.id, blobId);
            }
        }
    }
</script>
